import React, { useState, Fragment } from "react";
import moment from "moment";
import "moment/locale/en-gb";
import "moment/locale/de";
import "moment/locale/nl";
import "moment/locale/el";
import "moment/locale/es";
import "moment/locale/nl-be";
import "moment/locale/fr";
import "moment/locale/zh-cn";
import PropTypes from "prop-types";
import DateTime from "react-datetime";
import { filter, isEmpty } from "ramda";

const SelectDateAppointment = (props) => {
  const { handleValues, locale, availability, date } = props;

  const dateFutureMonth = moment().add(1, "M");
  const [plusCalentdar, setPlusCalendar] = useState(false);

  const onChangeValues = (value, plusCalentdar) => {
    handleValues(moment(value).format("DD/MM/YYYY"), "DATE");
    setPlusCalendar(plusCalentdar);
  };

  const valid = function (current) {
    return !isEmpty(filter((a) => current.isSame(a), availability));
  };

  return (
    <Fragment>
      <div className="dateInner__container">
        <DateTime
          dateFormat="YYYY-MM-DD"
          timeFormat={false}
          open={true}
          className={`datetime__table${!plusCalentdar ? "" : "--hide-pick"}`}
          onChange={(date) => onChangeValues(date, false)}
          value={moment(date, "DD/MM/YYYY")}
          locale={locale}
          isValidDate={valid}
          inputProps={{ placeholder: "N/A", disabled: true }}
        />
      </div>
    </Fragment>
  );
};

SelectDateAppointment.propTypes = {
  handleValues: PropTypes.func,
  locale: PropTypes.string,
  availability: PropTypes.array,
  date: PropTypes.any,
  setDate: PropTypes.func,
};

export default SelectDateAppointment;
